import type { ComponentProps } from 'react';
import { useImpressionRef } from '@zep/logger/react';
import { useAnswerVisibility } from '../../../stores/AnswerVisibilityProvider';
import { AnswerVisibilityToggle } from './AnswerVisibilityToggle';

/*
  정답 보기 전환율의 분모 — 토글이 마운트가 아니라 **화면에 보일 때** 1회 보낸다.

  관측을 시작하는 컴포넌트를 따로 둔 이유는 QuizBankEntryRow 와 같다.
  `useImpressionRef` 는 첫 교차에서 발화 완료로 표시해 다시 쏘지 않고, React 는 자식
  이펙트를 부모(`UserProvider`)보다 먼저 돌리므로 게이트 없이 관측을 걸면 이 이벤트만
  사용자·플랜 문맥 없이 저장된다. 그래서 부모가 로거 문맥이 실린 뒤에만 이 컴포넌트를
  렌더하고, 퀴즈가 바뀌면 key 로 다시 마운트해 노출을 새로 센다.
*/
export const TrackedAnswerVisibilityToggle = (props: Omit<ComponentProps<typeof AnswerVisibilityToggle>, 'rootRef'>) => {
  const {
    trackToggleView
  } = useAnswerVisibility();
  const impressionRef = useImpressionRef<HTMLDivElement>(trackToggleView);
  return <AnswerVisibilityToggle {...props} rootRef={impressionRef} data-sentry-element="AnswerVisibilityToggle" data-sentry-component="TrackedAnswerVisibilityToggle" data-sentry-source-file="TrackedAnswerVisibilityToggle.tsx" />;
};